import * as React from 'react';
import {connect, ConnectedProps} from 'react-redux';
import {I18nConfig} from 'src/js/model/i18n_config';
import {RootState} from 'src/js/store';

import {LanguageSwitcher} from './LanguageSwitcher';
import {I18N_REDUCER_STATE_ID} from '../i18n_constants';
import {changeCurrentLocale} from '../i18n_thunks';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface OwnProps {}

const mapState = (state: RootState) => ({
  i18nConfig: state[I18N_REDUCER_STATE_ID].i18nConfig,
  currentLocale: state[I18N_REDUCER_STATE_ID].currentLocale,
});

const mapDispatch = {
  changeCurrentLocaleAC: changeCurrentLocale,
};

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & OwnProps;

class LanguageSwitcherContainer extends React.PureComponent<Props> {
  static displayName: string = 'LanguageSwitcherContainer';

  constructor(props) {
    super(props);
    this.handleLocaleChange = this.handleLocaleChange.bind(this);
  }

  handleLocaleChange(locale) {
    const {changeCurrentLocaleAC} = this.props;
    changeCurrentLocaleAC(locale);
  }

  render() {
    const {currentLocale, i18nConfig} = this.props;
    const i18nConfigModel = new I18nConfig(i18nConfig);
    const languages = i18nConfigModel.getUsedApplicationLanguages();
    return i18nConfig && i18nConfigModel.isLoaded() && languages && languages.length > 1 ? (
      <LanguageSwitcher selectedLocale={currentLocale} languages={languages} onLocaleChange={this.handleLocaleChange} />
    ) : null;
  }
}

export default connector(LanguageSwitcherContainer);
